import React from 'react';
import { connect } from 'react-redux';
import axios from '../../config/axiosInstance';


import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Select from 'react-select';
import SelectMaterial from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { fetchEmployees } from '../../store/actions/employee';
import DataTable from '../../components/DataTable/DataTable';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import BankOfHoursDetails from '../../components/BankOfHoursDetails/BankOfHoursDetails';
import { setLoading } from '../../store/actions/general';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, DialogContentText, TextField } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import axiosInstance from '../../config/axiosInstance';
import Input from '../../components/Input/Input';



const styles = theme => ({
  input: {
    width: '40%',
    margin: theme.spacing(3),
  },
});

class ManageEmployees extends React.Component {
  state = {
    selected: null,
    selectedYear: null,
    date: '',
    years: [],
    bankPeriod: null,
    includeCurrentMonth: false,
    modal: null,
    time: '',
    descricao: '',
    idBank: '',
    lisEmployees: [],
    mesAno: '',
    discount: 0
  };


  componentDidMount() {
    // this.props.onFetchEmployees();
    this.getListEmployees();
  }

  getListEmployees = async () => {
    const result = await axiosInstance.get('/employee/list')
    this.setState({ lisEmployees: result.data.filter(e => e._optAlreadyHadBankHours) })
  }

  fetchPeriod = async (userId) => {
    this.props.onSetLoading(true);
    const response = await axios.get(`/timeSheet/generate/pointSheet/bi/bankHours/periods/${userId}`);
    const yearsPeriod = [];

    response.data.map(info => yearsPeriod.push(info));
    this.setState({ years: yearsPeriod, selectedYear: response.data && response.data[response.data.length - 1], date: response.data && response.data[response.data.length - 1].objs[response.data[response.data.length - 1].objs.length - 1].id });
    this.fetchBankPeriod(response.data && response.data[response.data.length - 1].objs[response.data[response.data.length - 1].objs.length - 1].id);
    this.props.onSetLoading(false);
  }

  fetchBankPeriod = async (bankPeriodId) => {
    this.props.onSetLoading(true);
    // const response = await axios.get(`/timeSheet/generate/pointSheet/bi/bankHours/id/${bankPeriodId}?includeCurrentMonth=${this.state.includeCurrentMonth}`);
    // const response = await axios.get(`/getBankHoursEmployee/${this.state.selected.id}`);
    // const companyId = JSON.parse(localStorage.getItem('companies')).find(x => x.companyId).companyId;
    // const bankHours = {
    // // "bankPeriodId" : bankPeriodId,
    //   "companyId" : companyId
    // }
    const token = localStorage.getItem('token');
    // const queryParams = new URLSearchParams(bankHours).toString();
    const response = await axios.get(`/getBankHours/${bankPeriodId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    this.setState({ bankPeriod: response.data });
    this.setState({ idBank: bankPeriodId });
    this.props.onSetLoading(false);
  }

  handleChange = (event) => {
    if (event.bankPeriodId) {
      this.props.fetchBankPeriod(event.id);
    }
    this.setState({
      selected: event, years: [], date: [], bankPeriod: null, selectedYear: null,
    });
    this.fetchPeriod(event.id);
  }

  handleChangeMaterial = (event) => {
    this.setState({ date: event.target.value });
    this.fetchBankPeriod(event.target.value);
  };

  handleChangeYear = (event) => {
    this.setState({ selectedYear: event.target.value });
  };

  toggleCheckbox = () => {
    this.setState({ includeCurrentMonth: !this.state.includeCurrentMonth }, () => {
      this.fetchBankPeriod(this.state.date);
    })
  }

  objectMap = (object, mapFn) => Object.keys(object).reduce((result, key) => {
    result[key] = mapFn(object[key]);
    return result;
  }, {})

  handleMenuOpen = () => {
    this.setState({ modal: true });
  };

  handleMenuClose = () => {
    this.setState({ modal: null });
  };

  handleMonthYearChange(event) {
    const { value } = event.target;
    const [month, year] = value.split('/');
    // Faça as validações necessárias para garantir que o valor esteja no formato correto

    this.setState({ mesAno: { month, year } });
  }


  minuteToHour = (m) => {
    if (typeof m === 'string' && m.length >= 2) {
      return m;
    }

    const signal = m < 0 ? '-' : (this.props.positive ? '+' : '');

    if (m < 0) {
      m *= -1;
    }

    if (m !== 0) {
      const hours = Math.floor(m / 60);
      let minutes = m % 60;
      if (minutes < 9) {
        minutes = `0${minutes}`;
      }
      return `${signal + hours}h ${minutes}m`;
    }
    return '00:00';
  }

  payHours = (event, type) => {
    switch (type) {
      case 'descricao':
        this.setState({ descricao: event.target.value });
        break;

      case 'time':
        this.setState({ time: event.target.value });
        break;

      case 'monthReference':
        this.setState({ mesAno: event.target.value });
        break;

      default:
        break;
    }
  }

  payMonthReference = (event, type) => {
    switch (type) {
      case 'descricao':
        this.setState({ mesAno: event.target.value });
        break;

      case 'time':
        this.setState({ time: event.target.value });
        break;

      default:
        break;
    }
  }

  registerPayHours = () => {
    let totalMinutes = 0;
    if (this.state.time && this.state.time.length) {
      let hours = '';
      let minutes = '';
      const separator = this.state.time.indexOf(':');
      let sign = 1;
      if (this.state.time.indexOf('-') === -1) {
        hours = this.state.time.slice(0, separator);
      } else {
        hours = this.state.time.slice(1, separator);
        sign = -1;
      }
      minutes = this.state.time.slice(separator + 1);
      totalMinutes = ((parseInt((hours * 60), 10) + parseInt(minutes, 10)) * sign);
    }
    const dateString = this.state.mesAno;
    const [month, year] = dateString.split('/');
    // Cria uma nova data com o dia 01, usando o mês e ano fornecidos
    const date = new Date(`${year}-${month}-01`);

    axios.post('/discountBank', {
      value: totalMinutes,
      monthRef: date,
      description: this.state.editDescricao,
      employeeId: this.state.selected.id,
      bankHoursEmployeeId: this.state.date
    })
      .then((response) => {
        this.handleMenuClose()
        this.fetchBankPeriod(this.state.idBank);
      })
      .catch((error) => {
        // console.log(error)
      });
  }


  renderMenu = () => {
    return (
      <div>
        <Button disabled={this.state.selected ? false : true} variant='outlined' color='primary' onClick={() => this.handleMenuOpen()}>
          ABATER HORAS
        </Button>
        <Dialog
          open={this.state.modal}
          onClose={() => this.handleMenuClose()}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Abater Horas.
          </DialogTitle>
          <DialogContent>
            <div>
              <DialogContentText>Informe o novo horário e uma justificativa.</DialogContentText>
              <Input
                elementType="maskedInput"
                name="name"
                label="Horário"
                mask={[/\d/, /\d/, /\d/, ':', /\d/, /\d/]}
                placeholder="00h00m"
                value={this.state.time}
                onChange={event => this.payHours(event, 'time')}
                required
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                autoFocus
                margin="dense"
                name="name"
                label="justificativa"
                type="text"
                onChange={event => this.payHours(event, 'descricao')}
                value={this.state.descricao}
                required
                fullWidth
              />
              <Input
                elementType="maskedInput"
                name="name"
                label="mês de referência"
                mask={[/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                placeholder="MM/AAAA"
                value={this.state.mesAno}
                onChange={event => this.payHours(event, 'monthReference')}
                required
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              disabled={this.state.time && this.state.descricao ? false : true}
              style={{ left: '-21px', bottom: ' 9px' }}
              onClick={() => this.registerPayHours()}>
              Enviar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  render() {
    const { loading } = this.props;
    const { lisEmployees } = this.state;
    const options = lisEmployees.map((i) => {
      i.value = i.id;
      i.label = i.name;
      return i;
    });

    const optionsEmployee = options.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });


    const filteredRows =
      this.props.bankOfHours.detailed ? this.props.bankOfHours.detailed.map((d) => {
        d.worked = this.minuteToHour(d.worked);
        d.expected = this.minuteToHour(d.expected);
        d.paid = this.minuteToHour(d.paid);
        d.extraHours = this.minuteToHour(d.extraHours);
        d.accumulated = this.minuteToHour(d.accumulated);
        d.bankHours = this.minuteToHour(d.bankHours);
        return this.objectMap(d, value => `${value}`);
      }) : [];

    const filteredRowsPeriod =
      this.state.bankPeriod && this.state.bankPeriod.totalCalculatedBankHours != null ? this.state.bankPeriod.totalCalculatedBankHours.detailed.map((d) => {
        d.worked = this.minuteToHour(d.worked);
        d.expected = this.minuteToHour(d.expected);
        d.paid = this.minuteToHour(d.paid);
        d.extraHours = this.minuteToHour(d.extraHours);
        d.accumulated = this.minuteToHour(d.accumulated);
        d.bankHours = this.minuteToHour(d.bankHours);
        return this.objectMap(d, value => `${value}`);
      }) : [];


    let columns = [
      { name: 'month', label: 'Mês' },
      { name: 'worked', label: 'Horas Trabalhadas' },
      { name: 'expected', label: 'Horas Previstas' },
    ];

    if (this.state.bankPeriod?.global?.includeExtraHours) {
      columns = [
        ...columns,
        { name: 'extraHours', label: 'Horas Extras' },
      ]
    }

    columns.push({ name: 'bankHours', label: 'Saldo do Banco' })
    columns.push({ name: 'accumulated', label: 'Saldo Acumulado' })
    columns.push({ name: 'paid', label: 'Valor Abatido' })


    return (
      <React.Fragment>
        <ContentHeader
          title="Banco de Horas"
          subtitle="Acompanhe o banco de horas de seus funcionários "
        />

        <Paper elevation={2} style={{ padding: '25px' }}>
          <div className="display-flex">
            <div style={{ width: '40%', marginRight: '5%' }} data-tut="reactour__Select">
              <Typography align="left" color="textSecondary">
                Escolha um usuário para visualizar suas informações
              </Typography>
              <Select
                options={optionsEmployee}
                onChange={this.handleChange}
                placeholder="Busque um usúario"
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ marginRight: '20px', display: 'flex', alignItems: 'center' }}>
                <InputLabel htmlFor="date">Inicio em: </InputLabel>
                <SelectMaterial
                  value={this.state.selectedYear}
                  onChange={this.handleChangeYear}
                  inputProps={{
                    name: 'ATUAL',
                    id: 'date',
                  }}
                  disabled={!this.state.selected}
                  style={{ minWidth: 50 }}
                >
                  {
                    this.state.years === [] ?
                      <MenuItem> nada </MenuItem>
                      :
                      this.state.years.map(year => (
                        <MenuItem key={year.period} value={year}>{year.period}</MenuItem>
                      ))

                  }
                </SelectMaterial>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <InputLabel htmlFor="date">Período: </InputLabel>
                <SelectMaterial
                  value={this.state.date}
                  onChange={this.handleChangeMaterial}
                  inputProps={{
                    name: 'date',
                    id: 'date',
                  }}
                  disabled={!this.state.selected || !this.state.selectedYear}
                  style={{ minWidth: 200 }}

                >
                  {
                    this.state.selectedYear && this.state.selectedYear.objs.map(date => (
                      <MenuItem value={date.id}>{date.interval}</MenuItem>
                    ))
                  }
                </SelectMaterial>
              </div>
            </div>
            {/* <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.includeCurrentMonth}
                  onChange={() => this.toggleCheckbox()}
                  value="includeCurrentMonth"
                  color="primary"
                  disabled={!this.state.selected}
                />
              }
              label="Incluir mês corrente no banco de horas"
              style={{ marginLeft: '10px' }}
            /> */}

            {this.renderMenu()}

          </div>

          <div style={{ display: 'flex', marginTop: '20px' }}>
            {
              !this.state.bankPeriod ? (
                <>
                  <BankOfHoursDetails bank={this.state.selected && this.state.selected.bankPeriodId ? this.props.bankOfHours : []} />
                  <Paper
                    elevation={2}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      marginLeft: '20px',
                      width: '100%'
                    }}
                  >
                    <span
                      style={{
                        textAlign: 'center',
                        marginRight: 'auto',
                        marginLeft: 'auto',
                        paddingTop: '20px',
                      }}
                    >
                      Detalhes
                    </span>
                    <DataTable rows={this.state.selected && this.state.selected.bankPeriodId ? filteredRows : []} align="center" columns={this.state.selected ? columns : []} pagination={false} loading={loading} />
                  </Paper>
                </>) : (
                <>
                  <BankOfHoursDetails bank={this.state.bankPeriod ? this.state.bankPeriod : []}/>
                  <Paper
                    elevation={2}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      marginLeft: '20px',
                      width: '100%',
                    }}
                  >
                    <span
                      style={{
                        textAlign: 'center',
                        marginRight: 'auto',
                        marginLeft: 'auto',
                        paddingTop: '20px',
                      }}
                    >
                      Detalhes
                    </span>
                    <DataTable rows={this.state.bankPeriod ? filteredRowsPeriod : []} align="center" columns={this.state.bankPeriod ? columns : []} pagination={false} loading={loading} />
                  </Paper>
                </>)
            }
          </div>

        </Paper>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  // employees: state.employee.employees.filter(e => e._optAlreadyHadBankHours),
  bankOfHours: state.bankOfHours.bankOfHours,
});

const mapDispatchToProps = dispatch => ({
  onSetLoading: loading => dispatch(setLoading(loading)),
  // onFetchEmployees: () => dispatch(fetchEmployees()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(ManageEmployees));

